import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '../../i18n/LocaleProvider.js';
import { cn } from '../../lib/cn.js';
import styles from './Spinner.module.css';
const SIZE_CLASS = {
    14: styles['size14'],
    16: styles['size16'],
    20: styles['size20'],
    24: styles['size24'],
    32: styles['size32'],
};
/** Indeterminate progress indicator (§0.5). Per ux.md, reserve this for a
 * SCOPED mutation (button spinner) — page/content loads use `<Skeleton>`. */
export function Spinner({ size = 16, className, label }) {
    const { t } = useI18n();
    return (_jsx("span", { role: "status", "aria-live": "polite", className: cn(styles['spinner'], SIZE_CLASS[size], className), children: _jsx("span", { className: styles['visuallyHidden'], children: label ?? t('common:state.loading') }) }));
}
